import { styled } from '@slal/ui';
import { Button } from '@slal/ui/buttons';
import { breakpointUp } from '@slal/ui/helpers';

export const StyledButton = styled(Button)`
    min-width: auto;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    padding: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[5]};
    border: 1px solid ${({ theme }) => theme.colors.blue__secondary__70}!important;
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.medium};
    line-height: ${({ theme }) => theme.lineHeights.input};

    ${breakpointUp.md`
        width:auto;
    `}

    &.generate-report:disabled {
        min-width: auto;
        width: 181px;
        cursor: not-allowed;
    }
`;
